// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/anise_main_logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_Navbar__pugEK {
  background-color: #ffffff;
  height: 69px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  .Navbar_Navbar__pugEK.Navbar_fixedPosition__iorBV {
    position: fixed;
    width: 100%;
  }
}
.Navbar_Navbar__pugEK nav {
  max-width: 1300px;
  align-self: center;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: 500;
  display: flex;
  position: static;
}
@media (max-width: 768px) {
  .Navbar_Navbar__pugEK nav {
    padding: 0 20px;
  }
}
.Navbar_Navbar__pugEK nav .Navbar_logo__YJM-Q {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 50px;
  width: 157px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS {
  display: flex;
  gap: 15px;
}
@media (max-width: 768px) {
  .Navbar_Navbar__pugEK nav .Navbar_links__s0NVS {
    display: none;
  }
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs {
  display: flex;
  align-items: center;
  gap: 5px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP {
  position: relative;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border-radius: 8px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_header__4I5I9 {
  height: 45px;
  align-items: center;
  display: flex;
  gap: 7px;
  padding: 0 15px;
  font-size: 14px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_header__4I5I9 span {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_header__4I5I9 svg {
  transition: 0.5s ease-in-out;
  font-size: 10px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG {
  z-index: 1;
  background-color: #ffffff;
  position: absolute;
  right: 0;
  display: none;
  font-size: 14px;
  border-radius: 8px;
  box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);
  -webkit-box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);
  -moz-box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV {
  height: 50px;
  width: 200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px 0 10px;
  gap: 10px;
  margin: 5px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.4s ease-in-out;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV:hover {
  background-color: #ffbc51;
  color: #ffffff;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV .Navbar_span__X4i7M {
  flex: 1 1;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV .Navbar_dropdown_item_icon__0vpq1 {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV .Navbar_dropdown_item_icon__0vpq1 svg {
  font-size: 20px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP:hover .Navbar_item_header__4I5I9 span {
  color: #015d8e;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP:hover .Navbar_item_header__4I5I9 svg {
  transform: rotate(180deg);
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_item_row__H2FHs .Navbar_item__30dgP:hover .Navbar_item_body__2N\\+jG {
  display: block;
  border: 2px solid #ffbc51;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_login_button__W\\+h8P {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 20px;
  border-left: 1px solid #ebebeb;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_login_button__W\\+h8P .Navbar_item__30dgP {
  position: relative;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border-radius: 8px;
  font-weight: 600;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_login_button__W\\+h8P .Navbar_item__30dgP .Navbar_item_header__4I5I9 {
  height: 45px;
  align-items: center;
  display: flex;
  gap: 7px;
  padding: 0 15px;
  font-size: 14px;
}
.Navbar_Navbar__pugEK nav .Navbar_links__s0NVS .Navbar_login_button__W\\+h8P .Navbar_item__30dgP:hover span {
  color: #015d8e;
}
.Navbar_Navbar__pugEK nav .Navbar_mobile_tab__t7XR7 {
  display: none;
}
@media (max-width: 768px) {
  .Navbar_Navbar__pugEK nav .Navbar_mobile_tab__t7XR7 {
    height: 40px;
    width: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 40px;
    cursor: pointer;
    z-index: 99;
  }
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 {
  position: fixed;
  left: 0;
  right: 0;
  top: 69px;
  padding: 40px 30px;
  background-color: #ffffff;
  height: calc(100vh - 109px);
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: scroll;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP {
  margin-bottom: 50px;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP .Navbar_item_header__4I5I9 {
  font-weight: 600;
  margin-bottom: 15px;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP .Navbar_item_header__4I5I9 svg {
  display: none;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV .Navbar_dropdown_item_icon__0vpq1 {
  display: none;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_mobile_menu_items__\\+0C6d .Navbar_item__30dgP .Navbar_item_body__2N\\+jG .Navbar_dropdown_item__o2NTV .Navbar_direction_icon__ZfTFN {
  display: none;
}
.Navbar_Navbar__pugEK .Navbar_mobile_menu__i0HV0 .Navbar_login_button__W\\+h8P {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 50px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.module.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,yBCGY;EDFZ,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADF;AAGE;EACE;IACE,eAAA;IACA,WAAA;EADJ;AACF;AAIE;EACE,iBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAFJ;AAII;EAXF;IAYI,eAAA;EADJ;AACF;AAGI;EACE,yDAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,4BAAA;AADN;AAII;EACE,aAAA;EACA,SAAA;AAFN;AAIM;EAJF;IAKI,aAAA;EADN;AACF;AAGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AADR;AAGQ;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;AADV;AAGU;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AADZ;AAGY;EACE,gBAAA;EACA,qBAAA;AADd;AAIY;EACE,4BAAA;EACA,eAAA;AAFd;AAMU;EACE,UAAA;EACA,yBC1EE;ED2EF,kBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,kBCzEI;ED0EJ,kDAAA;EACA,0DAAA;EACA,uDAAA;AAJZ;AAMY;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,kBCvFE;EDwFF,eAAA;EACA,4BAAA;AAJd;AAMc;EACE,yBCtGA;EDuGA,cCnGF;AD+Fd;AAOc;EACE,SAAA;AALhB;AAQc;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBC1GA;ADoGhB;AAQgB;EACE,eAAA;AANlB;AAcc;EACE,cC9HE;ADkHlB;AAec;EACE,yBAAA;AAbhB;AAgBY;EACE,cAAA;EACA,yBAAA;AAdd;AAoBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,8BAAA;AAlBR;AAoBQ;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AAlBV;AAoBU;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AAlBZ;AAsBY;EACE,cCtKI;ADkJlB;AA2BI;EACE,aAAA;AAzBN;AA2BM;EAHF;IAII,YAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;EAxBN;AACF;AA4BE;EACE,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBClMU;EDmMV,2BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;AA1BJ;AA6BM;EACE,mBAAA;AA3BR;AA6BQ;EACE,gBAAA;EACA,mBAAA;AA3BV;AA6BU;EACE,aAAA;AA3BZ;AAgCU;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA9BZ;AAgCY;EACE,aAAA;AA9Bd;AAiCY;EACE,aAAA;AA/Bd;AAsCI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AApCN","sourcesContent":["@import '../../variables';\n\n.Navbar {\n  background-color: $white-color;\n  height: 69px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 768px) {\n    &.fixedPosition {\n      position: fixed;\n      width: 100%;\n    }\n  }\n\n  nav {\n    max-width: 1300px;\n    align-self: center;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    font-weight: 500;\n    display: flex;\n    position: static;\n\n    @media (max-width: 768px) {\n      padding: 0 20px;\n    }\n\n    .logo {\n      background-image: url('../../assets/images/anise_main_logo.png');\n      height: 50px;\n      width: 157px;\n      background-position: center;\n      background-size: cover;\n      background-repeat: no-repeat;\n    }\n\n    .links {\n      display: flex;\n      gap: 15px;\n\n      @media (max-width: 768px) {\n        display: none;\n      }\n\n      .item_row {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n\n        .item {\n          position: relative;\n          cursor: pointer;\n          transition: 0.3s ease-in-out;\n          border-radius: 8px;\n\n          .item_header {\n            height: 45px;\n            align-items: center;\n            display: flex;\n            gap: 7px;\n            padding: 0 15px;\n            font-size: 14px;\n\n            span {\n              font-weight: 600;\n              letter-spacing: 0.5px;\n            }\n\n            svg {\n              transition: 0.5s ease-in-out;\n              font-size: 10px;\n            }\n          }\n\n          .item_body {\n            z-index: 1;\n            background-color: $white-color;\n            position: absolute;\n            right: 0;\n            display: none;\n            font-size: 14px;\n            border-radius: $border-radius;\n            box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);\n            -webkit-box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);\n            -moz-box-shadow: 10px 6px 18px -8px rgba(0, 0, 0, 0.29);\n\n            .dropdown_item {\n              height: 50px;\n              width: 200px;\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              padding: 0 20px 0 10px;\n              gap: 10px;\n              margin: 5px;\n              border-radius: $border-radius;\n              cursor: pointer;\n              transition: 0.4s ease-in-out;\n\n              &:hover {\n                background-color: $primary-color;\n                color: $white-color;\n              }\n\n              .span {\n                flex: 1;\n              }\n\n              .dropdown_item_icon {\n                height: 30px;\n                width: 30px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border-radius: $border-radius;\n\n                svg {\n                  font-size: 20px;\n                }\n              }\n            }\n          }\n\n          &:hover {\n            .item_header {\n              span {\n                color: $secondary-color;\n              }\n\n              svg {\n                transform: rotate(180deg);\n              }\n            }\n            .item_body {\n              display: block;\n              border: 2px solid $primary-color;\n            }\n          }\n        }\n      }\n\n      .login_button {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        padding-left: 20px;\n        border-left: 1px solid #ebebeb;\n\n        .item {\n          position: relative;\n          cursor: pointer;\n          transition: 0.3s ease-in-out;\n          border-radius: 8px;\n          font-weight: 600;\n\n          .item_header {\n            height: 45px;\n            align-items: center;\n            display: flex;\n            gap: 7px;\n            padding: 0 15px;\n            font-size: 14px;\n          }\n\n          &:hover {\n            span {\n              color: $secondary-color;\n            }\n          }\n        }\n      }\n    }\n\n    .mobile_tab {\n      display: none;\n\n      @media (max-width: 768px) {\n        height: 40px;\n        width: 40px;\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        border-radius: 40px;\n        cursor: pointer;\n        z-index: 99;\n      }\n    }\n  }\n\n  .mobile_menu {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 69px;\n    padding: 40px 30px;\n    background-color: $white-color;\n    height: calc(100vh - 109px);\n    z-index: 999;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    overflow-x: scroll;\n\n    .mobile_menu_items {\n      .item {\n        margin-bottom: 50px;\n\n        .item_header {\n          font-weight: 600;\n          margin-bottom: 15px;\n\n          svg {\n            display: none;\n          }\n        }\n\n        .item_body {\n          .dropdown_item {\n            margin-bottom: 10px;\n            display: flex;\n            align-items: center;\n            gap: 15px;\n\n            .dropdown_item_icon {\n              display: none;\n            }\n\n            .direction_icon {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n\n    .login_button {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      margin-bottom: 50px;\n      width: 100%;\n    }\n  }\n}\n","// _variables.scss\n\n$primary-color: #ffbc51;\n$primary-dark-color: #d99221;\n$secondary-color: #015d8e;\n$secondary-dark-color: #0b4b6d;\n$white-color: #ffffff;\n$black-color: #212121;\n$black-dark-color: #000000;\n$card-border-color: #e3ebf2;\n$input-background-color: #fafafa;\n\n$border-radius: 8px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Navbar": `Navbar_Navbar__pugEK`,
	"fixedPosition": `Navbar_fixedPosition__iorBV`,
	"logo": `Navbar_logo__YJM-Q`,
	"links": `Navbar_links__s0NVS`,
	"item_row": `Navbar_item_row__H2FHs`,
	"item": `Navbar_item__30dgP`,
	"item_header": `Navbar_item_header__4I5I9`,
	"item_body": `Navbar_item_body__2N+jG`,
	"dropdown_item": `Navbar_dropdown_item__o2NTV`,
	"span": `Navbar_span__X4i7M`,
	"dropdown_item_icon": `Navbar_dropdown_item_icon__0vpq1`,
	"login_button": `Navbar_login_button__W+h8P`,
	"mobile_tab": `Navbar_mobile_tab__t7XR7`,
	"mobile_menu": `Navbar_mobile_menu__i0HV0`,
	"mobile_menu_items": `Navbar_mobile_menu_items__+0C6d`,
	"direction_icon": `Navbar_direction_icon__ZfTFN`
};
export default ___CSS_LOADER_EXPORT___;
